import React from 'react';
import { motion } from 'framer-motion';
import { Users, BookOpen, Calendar, Zap } from 'lucide-react';
export function TargetAudience() {
  const audiences = [{
    icon: BookOpen,
    title: 'Personas celíacas recién diagnosticadas',
    desc: 'Que necesitan una guía clara y práctica.'
  }, {
    icon: Calendar,
    title: 'Personas que quieren organizar su alimentación',
    desc: 'Sin estrés y sin perder tiempo.'
  }, {
    icon: Users,
    title: 'Familias con integrantes celíacos',
    desc: 'Que buscan comidas saludables para todos.'
  }, {
    icon: Zap,
    title: 'Personas que quieren sentirse mejor físicamente',
    desc: 'Con más energía y mejor digestión.'
  }];
  // Assuming Calendar was imported in PainPoints, let's use Heart here instead to avoid missing import if we copy-paste, or just import Calendar.
  // I will just use Heart for the second one.
  return <section className="py-20 px-4 bg-forest text-warm-white" data-id="element-172">
      <div className="max-w-5xl mx-auto" data-id="element-173">
        <div className="text-center mb-16" data-id="element-174">
          <h2 className="font-serif text-4xl md:text-5xl text-cream mb-4" data-id="element-175">
            ¿PARA QUIÉN ES?
          </h2>
          <p className="text-xl text-sage/80" data-id="element-176">
            Diseñado para personas que quieren mejorar su vida sin gluten
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-177">
          {audiences.map((aud, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          x: idx % 2 === 0 ? -20 : 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-white/5 p-8 rounded-3xl border border-white/10 flex items-start gap-6" data-id="element-178">
              <div className="w-14 h-14 rounded-full bg-sage/20 flex items-center justify-center flex-shrink-0" data-id="element-179">
                <aud.icon className="w-7 h-7 text-sage" data-id="element-180" />
              </div>
              <div data-id="element-181">
                <h3 className="font-serif text-xl md:text-2xl text-cream mb-2" data-id="element-182">
                  {aud.title}
                </h3>
                <p className="text-sage/80" data-id="element-183">{aud.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}